<script>
export default {

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  methods: {
    onClick() {
      this.$emit('clicked', this.title);
    },
  },

};
</script>

<template lang="pug">
a.block.px-4.py-2.text-sm.leading-5.text-gray-700(
  href='#'
  class='hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900'
  role='menuitem'
  @click.prevent="onClick"
) {{ $t(title) }}
</template>
